import { render, staticRenderFns } from "./cadsetores.vue?vue&type=template&id=56210387&"
import script from "./cadsetores.vue?vue&type=script&lang=js&"
export * from "./cadsetores.vue?vue&type=script&lang=js&"
import style0 from "./cadsetores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports